import { create } from 'zustand';

interface PageTitleState {
  title: string;
  isShowFallback: boolean;
  redirectPath?: string;
  setTitle: (title: string) => void;
  setIsShowFallback: (isShow: boolean) => void;
  setRedirectPath: (path?: string) => void;
  resetTitle: () => void;
  resetIsShowFallback: () => void;
  resetRedirectPath: () => void;
}

export const usePageTitleStore = create<PageTitleState>((set) => ({
  title: '',
  isShowFallback: false,
  redirectPath: undefined,
  setTitle: (title: string) => set({ title }),
  setIsShowFallback: (isShowFallback: boolean) => set({ isShowFallback }),
  setRedirectPath: (redirectPath?: string) => set({ redirectPath }),
  resetTitle: () => set({ title: '' }),
  resetIsShowFallback: () => set({ isShowFallback: false }),
  resetRedirectPath: () => set({ redirectPath: undefined }),
}));

export const titleSelector = (state: PageTitleState) => state.title;
export const isShowFallbackSelector = (state: PageTitleState) =>
  state.isShowFallback;
export const redirectPathSelector = (state: PageTitleState) =>
  state.redirectPath;
